import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigationHistory } from '../contexts/NavigationContext.jsx';

// ナビゲーション履歴を自動的に追跡するコンポーネント
const NavigationTracker = ({ pageName }) => {
  const location = useLocation();
  const { pushHistory, clearHistory } = useNavigationHistory();

  useEffect(() => {
    // 画面タイトルマップ（App.jsxと同じものを使用）
    const pageMap = {
      '/dashboard': 'ダッシュボード',
      '/store-application-status': '申請状況照会',
      '/store-application': 'ストア申請',
      '/discussions': 'ディスカッション',
      '/projects': 'プロジェクト一覧',
      '/projects/create': 'プロジェクト登録',
      '/question-forest': '問いの森',
      '/wallet': 'ウォレット',
      '/mystakes': '信頼の使途',
      '/mystore': 'マイストア',
      '/my-stores': 'マイストア',
      '/store-recruitment-settings': '募集設定',
      '/store-search': 'ストア検索',
      '/stores': 'ストア一覧',
      '/product-search': '商品検索',
      '/cart': '購入予定の森',
      '/subscriptions': 'サブスクリプション',
      '/dao-application': 'DAO化申請',
      '/recruitments': '募集一覧',
      '/badges': 'バッジ一覧',
      '/titles': '肩書き一覧',
      '/chat': 'チャットメニュー',
      '/friends': '友達リスト',
      '/desire-pool': '需要の発酵池',
      '/system-parameter-settings': 'システムパラメータ設定',
      '/special-rewards': '特別報酬設定',
      '/forest-ecosystem': 'エコサイクル・マイニングとは',
      '/practice-guide': '真決DAO実践ガイド',
    };

    // 動的ルートの処理
    const getPageTitle = (pathname) => {
      // 静的マップから取得
      if (pageMap[pathname]) {
        return pageMap[pathname];
      }

      // 動的ルートの処理
      if (pathname.startsWith('/store/') && pathname.endsWith('/edit')) {
        return '商品編集';
      }
      if (pathname === '/store/items/new') {
        return '新規商品追加';
      }
      if (pathname.startsWith('/stores/') && pathname.split('/').length === 3) {
        const storeId = pathname.split('/')[2];
        if (!isNaN(storeId)) {
          return 'ストア詳細';
        }
      }
      if (pathname.startsWith('/recruitment/')) {
        const parts = pathname.split('/');
        if (parts.length === 4) {
          const typeMap = {
            store: 'ストア募集詳細',
            dao: 'DAO募集詳細',
            task: 'タスク募集詳細',
          };
          return typeMap[parts[2]] || '募集詳細';
        }
      }
      if (
        pathname.startsWith('/project/') ||
        (pathname.startsWith('/projects/') && pathname.split('/').length === 3)
      ) {
        return 'プロジェクト詳細';
      }
      if (pathname.startsWith('/dao/') && pathname.split('/').length === 3) {
        return 'DAO詳細';
      }
      if (pathname.startsWith('/questions/') && pathname.endsWith('/create')) {
        return '問いを投稿';
      }
      if (
        pathname.startsWith('/questions/') &&
        pathname.split('/').length === 3
      ) {
        return '問い詳細';
      }
      if (pathname.startsWith('/personal-chat/')) {
        return '個人チャット';
      }
      if (pathname.startsWith('/group-chat/')) {
        return 'グループチャット';
      }
      if (pathname.startsWith('/dao-chat/')) {
        return 'DAOチャット';
      }
      if (pathname.startsWith('/store-chat/')) {
        return 'ストアチャット';
      }
      if (pathname.startsWith('/profile/')) {
        return 'プロフィール';
      }
      if (pathname.startsWith('/trust/network/')) {
        return 'アクターネットワーク';
      }
      if (
        pathname.startsWith('/store-application/') &&
        pathname.split('/').length === 3
      ) {
        return 'ストア申請詳細';
      }

      // 不明なルート：履歴に追加しない（nullを返す）
      return null;
    };

    // propsでpageNameが渡されている場合はそれを優先、なければ自動判定
    const title = pageName || getPageTitle(location.pathname);

    // ダッシュボードに遷移した場合は履歴をクリア
    if (location.pathname === '/dashboard') {
      clearHistory();
      return;
    }

    // 特定のパス（Introduction、Login等）では履歴に追加しない
    // また、不明なルート（titleがnull）の場合も履歴に追加しない
    const excludedPaths = ['/introduction', '/login', '/register', '/kyc'];
    if (!excludedPaths.includes(location.pathname) && title !== null) {
      pushHistory(location.pathname, title);
    }
  }, [location, pushHistory, clearHistory, pageName]);

  return null;
};

export default NavigationTracker;
